import React from "react"
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import ReviewSlider from "../review-slider/reviewSlider";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import "./videoPlayer.scss"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const VideosPlayer = (props: ReferenciaContenido) => {

   return (
      <div className="m-videos">
         <div className="m-videos__upper">
            <h2 className="m-videos__upper__title">{props.tituloGeneral}</h2>
            <p className="m-videos__upper__subtitle">{documentToReactComponents(props.descripcion.json)}</p>
         </div>
         <div className="m-videos__list">
         {props.referenciaPlantillaContenido && (
          <ReviewSlider 
            reviews={props.referenciaPlantillaContenido} 
            gtmClass={`${normalizeTwoWords(props.nombreCategoria)}${normalizeTwoWords(props.tituloGeneral)}`}
            video={true}
          />
        )}
         </div>
      </div>
   )
}

export default VideosPlayer